/*
We have these functions centralized in this file so that
other processes like the creation of a breadcrumb or
a sitemap can also easily make use of them.
 */

const slugify = require('slugify');

const slug = (text) => {
  text = text.replace(/[\s.]/g, '-');
  text = text.replace(/-+/g, '-');
  return slugify(text, {
    replacement: '-', // replace spaces with replacement character, defaults to `-`
    remove: undefined, // remove characters that match regex, defaults to `undefined`
    lower: true, // convert to lower case, defaults to `false`
    strict: true, // strip special characters except replacement, defaults to `false`
    trim: true, // trim leading and trailing replacement chars, defaults to `true`
  });
};

module.exports = {
  category: (categories, categoryId, language, page) => `/${categories.find((category) => category.id === categoryId).slug[language]}${page > 1 ? `/page/${page}` : ''}`,
  categoryoverview: (language) => ({
    de: '/kategorien',
    en: '/categories',
    nl: '/categorieen',
  })[language],
  charts: () => '/charts',
  composer: () => '/info/composer',
  config: () => '/swinger-data/config.json',
  deviceinfo: () => '/info/device-info',
  director: (director, language) => `${({
    de: '/regisseur',
    en: '/director',
    nl: '/directeur',
  })[language]}/${director.slug ? director.slug : slug(director.name)}`,
  movie: (movie, studio, language) => `/${studio.slug[language] ? studio.slug[language] : studio.slug.en}/${movie.slug[language] ? movie.slug[language] : movie.slug.en}`,
  movieoverview: (language, page) => `${({
    de: '/filme',
    en: '/movies',
    nl: '/films',
  })[language]}${page > 1 ? `/page/${page}` : ''}`,
  newreleases: (language, page) => `/recently-added${page > 1 ? `/page/${page}` : ''}`,
  performer: (performer, language) => `/${({
    de: '/pornostar',
    en: '/pornstar',
    nl: '/pornoster',
  })[language]}/${performer.slug[language] ? performer.slug[language] : performer.slug.en}`,
  performeroverview: (language, page) => `${({
    de: '/pornostars',
    en: '/pornstars',
    nl: '/pornosterren',
  })[language]}${page > 1 ? `/page/${page}` : ''}`,
  search: () => '/search',
  series: (series, studio, language) => `${({
    de: '/serie',
    en: '/series',
    nl: '/serie',
  })[language]}/${studio.slug[language] ? studio.slug[language] : studio.slug.en}/${series.slug[language] ? series.slug[language] : series.slug.en}`,
  specialprice: (language, page) => `/special-price${page > 1 ? `/page/${page}` : ''}`,
  speedometer: () => '/speedometer',
  start: () => '',
  studio: (studio, language) => `/studio/${studio.slug[language] ? studio.slug[language] : studio.slug.en}`,
  studiooverview: (language, firstLetter, page) => `/studios${firstLetter ? `/${firstLetter}` : ''}${page > 1 ? `/page/${page}` : ''}`,
  test: () => '/test',
  videocastinfo: () => '/info/videocast',
};



// WEBPACK FOOTER //
// ./src/_utilities/createpermalinks.js